// extracted by mini-css-extract-plugin
export default {"p_footerLink":"Footer_p_footerLink__2VNVf"};